import React from 'react';
import propTypes from 'prop-types';
import { getMessage } from 'util/locale';
import { get } from 'lodash';

// components
import BaseModal from 'common/modals/BaseModal';
import ModalTextInput from 'common/modals/ModalTextInput';

const baseString = 'vra-duplicate-modal';

let DuplicateModal = ({
  duplicateModal,
  onCancelDuplicateModal,
  onChangeDuplicateInput,
  onSaveDuplicateModal,
  scriptId,
  validationResult
}) => {
  if (!duplicateModal) {
    return null;
  }

  const { value: defaultDuplicateScriptName, duplicateType, uiLocation } = duplicateModal;
  const isInvalid = get(validationResult, 'isInvalid', false);

  return (
    <BaseModal
      header={getMessage(`title-text__duplicate-prescription--${duplicateType}`)}
      isInvalid={isInvalid}
      onCancel={() => { onCancelDuplicateModal({ duplicateType, uiLocation }); }}
      onSave={() => { onSaveDuplicateModal({ scriptId, duplicateType, uiLocation }); }}
      saveText={getMessage('button-text__save-changes')}
      shouldCloseOnOverlayClick={false}
    >
      <ModalTextInput
        baseString={baseString}
        defaultValue={defaultDuplicateScriptName}
        labelText={getMessage('label-text__rx-name')}
        onChange={(e) => { onChangeDuplicateInput(e.target.value); }}
        validationResult={validationResult}
      />
    </BaseModal>
  );
};
DuplicateModal.propTypes = {
  duplicateModal: propTypes.object,
  onCancelDuplicateModal: propTypes.func.isRequired,
  onChangeDuplicateInput: propTypes.func.isRequired,
  onSaveDuplicateModal: propTypes.func.isRequired,
  scriptId: propTypes.string,
  validationResult: propTypes.object
};

export default DuplicateModal;
